<template>
	<div class="margin-left list">
		<div class="flex margin-bottom-sm align-center topall bg-white">
			<p @click="chose(index)" class="flex-sub text-center pointer" :class="topindex == index?'active text-theme':''" v-for="(item,index) in top" :key="index">{{item.name}}</p>
			
		</div>
		<div v-if="total != 0">
			<div v-for="(item,indx) in list" :key="indx" v-if="topindex == 0">
				<StationList  :data="item" :width="922" :height="184" :size="24"></StationList>
			</div>
			<div v-for="(item,indx) in list" :key="indx" v-if="topindex == 1">
				<ResumeList  :data="item" :width="922" :height="184" :size="24"></ResumeList>
			</div>
			<div v-if="topindex == 2">
				<Course></Course>
			</div>
			<div class="pagination">
				<el-pagination
				@current-change="handleCurrentChange"
				  background
				  layout="prev, pager, next"
				  prev-text="上一页"
				  next-text="下一页"
				  :total="total">
				</el-pagination>
			</div>
		</div>
		<div class="text-center" v-else>
			<el-empty description="暂无数据"></el-empty>
		</div>
	</div>
</template>

<script>
	import StationList from '../seen/station-list.vue';
	import CourseList from '../../list/course-list.vue';
	import ResumeList from '../seen/resume-list.vue';
	import Course from './course.vue';
	
	export default {
		components: {
			CourseList,
			StationList,
			ResumeList,
			Course
		},
		data() {
			return {
				top:[
					{
						name:'收藏的找活'
					},{
						name:'收藏的招工'
					},{
						name:'收藏的课程'
					}
				],//类型
				topindex:0,//选中的类型下表
				page:1,
				total:0,//
				list:[]
			};
		},
		created() {
			this.getlist()
		},
		methods: {
			//选择类型
			chose(index){
				this.topindex = index
				if(index != 2){
					this.getlist()
				}
				
			},
			//去详情
			godetail(){
				let type = {
					type:'exadetail',
					typeone:'examine'
				}
				this.$emit('gettype',type)
			},
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getlist();
			},
			/**
			 * 收藏列表
			 * TODO
			 * */
			getlist(){
				this.ajax('get', '/api/pc/collection/getList', {
					stat:this.topindex,
					page:this.page,
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.list = res.data.data
						console.log(this.list);
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
					}else{
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.list{
		width: 921px;
	}
	.topall{
		width: 921px;
		height: 69px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 10px;
		p{
			height: 69px;
			line-height: 69px;
		}
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
	.active{
		
		position: relative;
		&:after{
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			width: 27px;
			height: 6px;
			background: #0B837C;
			border-radius: 3px;
			content: '';
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/my/collect/collect.vue